<template>
  <div class="card p-3 p-md-4 shadow-sm">
    <!-- Header con controles -->
    <div class="mb-3 mb-md-4">
      <!-- Botón de regreso -->
      <button
        class="btn btn-outline-secondary btn-sm mb-3"
        @click="$router.push('/inicio')"
        type="button"
      >
        <i class="bi bi-arrow-left me-1"></i> Regresar
      </button>

      <h3 class="m-0 mb-3">Reporte de Pagos</h3>

      <!-- Controles de fecha -->
      <div class="row g-2 mb-2">
        <div class="col-6 col-md-auto">
          <label class="form-label small mb-1">Desde:</label>
          <input type="date" v-model="fechaInicio" class="form-control form-control-sm" @change="obtenerReporte" />
        </div>
        <div class="col-6 col-md-auto">
          <label class="form-label small mb-1">Hora inicio:</label>
          <input type="time" v-model="horaInicio" class="form-control form-control-sm" @change="obtenerReporte" />
        </div>
        <div class="col-6 col-md-auto">
          <label class="form-label small mb-1">Hasta:</label>
          <input type="date" v-model="fechaFin" class="form-control form-control-sm" :min="fechaInicio" @change="obtenerReporte" />
        </div>
        <div class="col-6 col-md-auto">
          <label class="form-label small mb-1">Hora fin:</label>
          <input type="time" v-model="horaFin" class="form-control form-control-sm" @change="obtenerReporte" />
        </div>
        <div class="col-6 col-md-auto">
          <label class="form-label small mb-1">Ordenar por:</label>
          <select v-model="ordenar" class="form-select form-select-sm" @change="obtenerReporte" style="min-width:160px">
            <option value="metodo_asc">Método (A-Z)</option>
            <option value="total_desc">Total (mayor)</option>
            <option value="total_asc">Total (menor)</option>
          </select>
        </div>
        <div class="col-6 col-md-auto d-flex align-items-end">
          <button type="button" class="btn btn-outline-secondary btn-sm w-100" @click="limpiarFechas" title="Limpiar fechas">
            <i class="bi bi-x-circle me-1"></i> <span class="d-none d-sm-inline">Limpiar</span>
          </button>
        </div>
        <div class="col-6 col-md-auto d-flex align-items-end">
          <button
            type="button"
            class="btn btn-danger btn-sm w-100"
            @click="descargarPDF"
            :disabled="!reporte.resumen?.length"
            title="Descargar reporte en PDF"
          >
            <i class="bi bi-file-pdf me-1"></i> <span class="d-none d-sm-inline">PDF</span>
          </button>
        </div>
      </div>
    </div>

    <!-- TABLA RESUMEN -->
    <div v-if="reporte.resumen?.length" class="mb-4">
      <h5 class="h6 mb-2">Totales por Método de Pago</h5>
      <div class="table-responsive">
        <table class="table table-bordered table-sm text-center align-middle">
          <thead class="table-light">
            <tr>
              <th class="small">Método</th>
              <th class="small d-none d-lg-table-cell">Hotel (Q)</th>
              <th class="small d-none d-lg-table-cell">Servicios (Q)</th>
              <th class="small d-none d-lg-table-cell">Tienda (Q)</th>
              <th class="small d-none d-lg-table-cell">Rest. (Q)</th>
              <th class="small">Total (Q)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fila in resumenOrdenado" :key="fila.IdMetodoPago">
              <td class="small text-start">{{ fila.NombreMetodoPago }}</td>
              <td class="small d-none d-lg-table-cell">Q{{ Number(fila.TotalHotel).toFixed(2) }}</td>
              <td class="small d-none d-lg-table-cell">Q{{ Number(fila.TotalServiciosExtra).toFixed(2) }}</td>
              <td class="small d-none d-lg-table-cell">Q{{ Number(fila.TotalTienda).toFixed(2) }}</td>
              <td class="small d-none d-lg-table-cell">Q{{ Number(fila.TotalRestaurante).toFixed(2) }}</td>
              <td class="small fw-bold">
                Q{{ (Number(fila.TotalHotel) + Number(fila.TotalServiciosExtra) + Number(fila.TotalTienda) + Number(fila.TotalRestaurante)).toFixed(2) }}
              </td>
            </tr>
          </tbody>
          <tfoot class="table-secondary">
            <tr>
              <td class="small fw-bold">TOTALES</td>
              <td class="small fw-bold d-none d-lg-table-cell">Q{{ totalHotel.toFixed(2) }}</td>
              <td class="small fw-bold d-none d-lg-table-cell">Q{{ totalServiciosExtra.toFixed(2) }}</td>
              <td class="small fw-bold d-none d-lg-table-cell">Q{{ totalTienda.toFixed(2) }}</td>
              <td class="small fw-bold d-none d-lg-table-cell">Q{{ totalRestaurante.toFixed(2) }}</td>
              <td class="small fw-bold text-primary">Q{{ totalGeneral.toFixed(2) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Desglose en móvil -->
      <div class="d-lg-none mt-3">
        <div class="row g-2 text-center">
          <div class="col-6">
            <div class="border rounded p-2">
              <div class="small text-muted">Hotel</div>
              <div class="fw-bold">Q{{ totalHotel.toFixed(2) }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="border rounded p-2">
              <div class="small text-muted">Servicios</div>
              <div class="fw-bold">Q{{ totalServiciosExtra.toFixed(2) }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="border rounded p-2">
              <div class="small text-muted">Tienda</div>
              <div class="fw-bold">Q{{ totalTienda.toFixed(2) }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="border rounded p-2">
              <div class="small text-muted">Restaurante</div>
              <div class="fw-bold">Q{{ totalRestaurante.toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DETALLES TARJETA -->
    <div v-if="reporte.detalles_tarjeta?.length" class="mb-4">
      <h5 class="h6 mb-2">Detalles Tarjeta</h5>
      <div class="table-responsive">
        <table class="table table-bordered table-sm text-center align-middle">
          <thead class="table-light">
            <tr>
              <th class="small">#</th>
              <th class="small">Monto (Q)</th>
              <th class="small d-none d-md-table-cell">Referencia</th>
              <th class="small">Fecha/Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fila, index) in reporte.detalles_tarjeta" :key="index">
              <td class="small">{{ index + 1 }}</td>
              <td class="small">Q{{ Number(fila.Monto).toFixed(2) }}</td>
              <td class="small d-none d-md-table-cell">{{ fila.NumeroReferencia || '-' }}</td>
              <td class="small">{{ formatearFechaHoraCorta(fila.FechaHora) }}</td>
            </tr>
          </tbody>
          <tfoot class="table-secondary">
            <tr>
              <td class="small fw-bold">TOTAL</td>
              <td class="small fw-bold">Q{{ totalTarjeta.toFixed(2) }}</td>
              <td class="d-none d-md-table-cell" colspan="2"></td>
              <td class="d-md-none"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- DETALLES DEPÓSITO -->
    <div v-if="reporte.detalles_deposito?.length" class="mb-4">
      <h5 class="h6 mb-2">Detalles Depósito/Transferencia</h5>
      <div class="table-responsive">
        <table class="table table-bordered table-sm text-center align-middle">
          <thead class="table-light">
            <tr>
              <th class="small">#</th>
              <th class="small">Monto (Q)</th>
              <th class="small d-none d-md-table-cell">Referencia</th>
              <th class="small d-none d-lg-table-cell">Banco</th>
              <th class="small d-none d-lg-table-cell">Cuenta</th>
              <th class="small">Fecha/Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fila, index) in reporte.detalles_deposito" :key="index">
              <td class="small">{{ index + 1 }}</td>
              <td class="small">Q{{ Number(fila.Monto).toFixed(2) }}</td>
              <td class="small d-none d-md-table-cell">{{ fila.NumeroReferencia || '-' }}</td>
              <td class="small d-none d-lg-table-cell">{{ fila.Banco || '-' }}</td>
              <td class="small d-none d-lg-table-cell">{{ fila.NumeroCuenta || '-' }}</td>
              <td class="small">{{ formatearFechaHoraCorta(fila.FechaHora) }}</td>
            </tr>
          </tbody>
          <tfoot class="table-secondary">
            <tr>
              <td class="small fw-bold">TOTAL</td>
              <td class="small fw-bold">Q{{ totalDeposito.toFixed(2) }}</td>
              <td class="d-none d-md-table-cell" colspan="4"></td>
              <td class="d-md-none"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Si no hay nada -->
    <div v-if="!reporte.resumen?.length" class="text-center text-muted py-4">
      <i class="bi bi-inbox fs-1 d-block mb-2"></i>
      <p class="mb-0">No hay datos para el rango de fechas seleccionadas.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "ReportePagosDia",
  data() {
    const hoy = new Date().toLocaleDateString("en-CA");
    return {
      fechaInicio: hoy,
      horaInicio: '00:00',
      fechaFin: hoy,
      horaFin: '23:59',
      ordenar: 'metodo_asc',
      reporte: {},
    };
  },
  computed: {
    resumenOrdenado() {
      if (!this.reporte.resumen) return [];
      const arr = [...this.reporte.resumen];
      const total = (f) => Number(f.TotalHotel) + Number(f.TotalServiciosExtra) + Number(f.TotalTienda) + Number(f.TotalRestaurante);
      switch (this.ordenar) {
        case 'total_desc': return arr.sort((a, b) => total(b) - total(a));
        case 'total_asc':  return arr.sort((a, b) => total(a) - total(b));
        default:           return arr.sort((a, b) => (a.NombreMetodoPago || '').localeCompare(b.NombreMetodoPago || ''));
      }
    },
    totalHotel() {
      if (!this.reporte.resumen) return 0;
      return this.reporte.resumen.reduce((sum, f) => sum + Number(f.TotalHotel), 0);
    },
    totalServiciosExtra() {
      if (!this.reporte.resumen) return 0;
      return this.reporte.resumen.reduce((sum, f) => sum + Number(f.TotalServiciosExtra), 0);
    },
    totalTienda() {
      if (!this.reporte.resumen) return 0;
      return this.reporte.resumen.reduce((sum, f) => sum + Number(f.TotalTienda), 0);
    },
    totalRestaurante() {
      if (!this.reporte.resumen) return 0;
      return this.reporte.resumen.reduce((sum, f) => sum + Number(f.TotalRestaurante), 0);
    },
    totalGeneral() {
      return this.totalHotel + this.totalServiciosExtra + this.totalTienda + this.totalRestaurante;
    },
    totalTarjeta() {
      if (!this.reporte.detalles_tarjeta) return 0;
      return this.reporte.detalles_tarjeta.reduce((sum, f) => sum + Number(f.Monto), 0);
    },
    totalDeposito() {
      if (!this.reporte.detalles_deposito) return 0;
      return this.reporte.detalles_deposito.reduce((sum, f) => sum + Number(f.Monto), 0);
    }
  },
  methods: {
    async obtenerReporte() {
      // Validar que ambas fechas estén presentes y que fechaFin >= fechaInicio
      if (!this.fechaInicio || !this.fechaFin) return;
      if (this.fechaFin < this.fechaInicio) return;

      try {
        const res = await axios.get(`${API_URL}/reporte-pagos-dia`, {
          params: {
            fechainicio: this.fechaInicio,
            fechafin: this.fechaFin,
            hora_inicio: this.horaInicio,
            hora_fin: this.horaFin,
          },
        });
        this.reporte = res.data;
      } catch (error) {
        console.error("Error obteniendo reporte:", error);
        this.reporte = {};
      }
    },
    limpiarFechas() {
      this.fechaInicio = "";
      this.horaInicio = '00:00';
      this.fechaFin = "";
      this.horaFin = '23:59';
      this.ordenar = 'metodo_asc';
      this.reporte = {};
    },
    formatearFechaHora(fechaHora) {
      if (!fechaHora) return '-';
      const fecha = new Date(fechaHora);
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear();
      const hora = fecha.getHours().toString().padStart(2, '0');
      const minutos = fecha.getMinutes().toString().padStart(2, '0');
      return `${dia}/${mes}/${anio} ${hora}:${minutos}`;
    },
    formatearFechaHoraCorta(fechaHora) {
      if (!fechaHora) return '-';
      const fecha = new Date(fechaHora);
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const hora = fecha.getHours().toString().padStart(2, '0');
      const minutos = fecha.getMinutes().toString().padStart(2, '0');
      return `${dia}/${mes} ${hora}:${minutos}`;
    },
    async descargarPDF() {
      if (!this.fechaInicio || !this.fechaFin) {
        alert('Por favor selecciona un rango de fechas');
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/reporte-pagos-dia-pdf`, {
          params: {
            fechainicio: this.fechaInicio,
            fechafin: this.fechaFin,
            hora_inicio: this.horaInicio,
            hora_fin: this.horaFin,
            ordenar: this.ordenar,
          },
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Reporte_Pagos_${this.fechaInicio}_${this.fechaFin}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      } catch (error) {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const json = JSON.parse(text);
            alert(json.error || json.message || 'Error al generar el PDF');
          } catch { alert('Error al generar el PDF'); }
        } else {
          console.error('Error descargando PDF:', error);
          alert('Error al generar el PDF');
        }
      }
    }
  },
  mounted() {
    this.obtenerReporte();
  },
};
</script>

<style scoped>
table th,
table td {
  vertical-align: middle;
}

/* Mejorar legibilidad en móvil */
@media (max-width: 768px) {
  .card {
    padding: 0.75rem !important;
  }

  .table-responsive {
    font-size: 0.875rem;
  }

  .table-sm td,
  .table-sm th {
    padding: 0.4rem;
  }

  /* Hacer más compactos los números en móvil */
  .small {
    font-size: 0.75rem !important;
  }

  h5.h6 {
    font-size: 0.95rem;
    font-weight: 600;
  }

  /* Ajustar los cards de resumen */
  .border.rounded {
    background-color: #f8f9fa;
  }
}

/* Estilos para tablets */
@media (min-width: 769px) and (max-width: 991px) {
  .table-responsive {
    font-size: 0.9rem;
  }
}

/* Asegurar que no haya overflow horizontal no deseado */
.table-responsive {
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}
</style>
